// Curated Pexels CDN images keyed to landing-page category tiles and to every
// subcategory tile on the /categories page. All URLs use Pexels' CDN with
// auto-compress; lazy-loaded by the consuming components.
const px = (id, name) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300`;

export const CATEGORY_IMAGES = {
  // === Top-level group tiles (used on landing page) ===
  "Home Services": "https://customer-assets.emergentagent.com/job_merchant-scores-1/artifacts/227qvx5d_ChatGPT%20Image%20Jun%2030%2C%202026%2C%2002_03_01%20AM.png",
  "Pool Service": px(6195260, "pool-brushing"),
  "Apparel & Gifts": px(4429528, "apparel"),
  "Cleaning": "https://customer-assets.emergentagent.com/job_merchant-scores-1/artifacts/sy7ysx7e_ChatGPT%20Image%20Jun%2030%2C%202026%2C%2002_04_49%20AM.png",
  "Landscaping & Outdoor": "https://customer-assets.emergentagent.com/job_merchant-scores-1/artifacts/cq4y0xhn_ChatGPT%20Image%20Jun%2030%2C%202026%2C%2002_08_23%20AM.png",
  "Construction & Remodeling": px(1216589, "construction"),
  "Moving & Storage": px(4506270, "moving-boxes"),
  "Auto Services": px(3807329, "auto"),
  "Food & Drink": px(1267320, "food"),
  "Beauty & Spas": px(3993449, "spa"),
  "Health & Medical": px(4021775, "medical"),
  "Fitness": px(1552242, "fitness"),
  "Pets": px(1108099, "pets"),
  "Professional Services": px(220453, "person-in-suit"),
  "Real Estate": px(280222, "house"),
  "Financial Services": px(210600, "money"),
  "Education & Tutoring": px(1181534, "education"),
  "Events & Weddings": px(1247841, "bride"),
  "Shopping": px(5868722, "shopping"),
  "Arts & Entertainment": px(1267349, "club-bar"),
  "Nightlife": px(274192, "cocktail"),
  "Hotels & Travel": px(261102, "hotel"),
  "Local Services": px(3760067, "smiling-retail-worker"),
  "Childcare & Family": px(8612998, "toddler-in-school"),
  "Religious & Community": px(208315, "community"),
  "Technology": px(1714208, "computer"),
  "Senior & Disability": px(7551752, "senior"),

  // === Home Services ===
  "Plumbing": px(6419128, "plumb"),
  "Electrical": px(257736, "electric"),
  "HVAC & Heating": px(8961065, "hvac-ac-unit-worker"),
  "Roofing": px(5825576, "roofer-shingles"),
  "Painting": px(5691661, "painter-painting-wall"),
  "Flooring": px(5825589, "tile-installation"),
  "Handyman": px(8092524, "ceiling-fan-install"),
  "Pest Control": px(8961125, "pest-control-spraying"),
  "Appliance Repair": px(8961116, "dryer-repair"),
  "Small Engine Repair": px(4489732, "small-engine-mechanic"),
  "Locksmiths": px(8961036, "locksmith-making-key"),
  "Drywall": px(8085520, "drywall-installer"),
  "Insulation": px(8092529, "insulation-installer"),
  "Foundation Repair": px(1216544, "foundation"),
  "Garage Door Services": px(8961067, "garage-door-worker"),
  "Junk Removal": px(6157049, "junk-into-dumptruck"),
  "Window Installation": px(8961090, "window-installer"),
  "Pool Repair": px(7501942, "pool-pump-service"),
  "Pool Builder": px(1438834, "pool-build"),
  "Pool Tile Cleaning": px(5961072, "pool-tile-cleaning-spray"),
  "Pool Remodeling": px(5691634, "pool-remodel-demolition"),
  "Pool Store": px(5961075, "pool-chemicals"),
  "Outdoor Lighting": px(2225617, "low-voltage-outdoor-lights"),
  "Pet Waste Removal": px(5731866, "pet-waste-scooper"),
  "Pressure Washing": px(5910749, "worker-pressure-washing"),
  "Garbage Can Cleaning": px(4108809, "garbage-can-pressure-wash"),

  // === Apparel & Gifts ===
  "DTF Printing": px(6612377, "dtf-printer"),
  "DTG Printing": px(6612369, "dtg-tshirt-printer"),
  "Sublimation": px(8348624, "sublimation-printer"),
  "Vinyl": px(6612386, "vinyl-cutter"),
  "Embroidery": px(8087730, "embroidery-machine"),
  "Laser Engraving": px(5709637, "laser-engraver"),

  // === Cleaning ===
  "House Cleaning": px(4099267, "maid-cleaning"),
  "Carpet Cleaning": px(4108715, "carpet"),
  "Window Washing": px(4239035, "window-wash"),
  "Office Cleaning": px(5560019, "cubicle-cleaning"),
  "Move-in/Move-out Cleaning": px(4246098, "movers-working"),

  // === Landscaping & Outdoor ===
  "Lawn Care": px(6231836, "mowing-yard"),
  "Tree Services": px(2138126, "tree-branch-cutting"),
  "Irrigation": px(2647714, "sprinkler-head"),
  "Fencing": px(2310538, "fence"),
  "Decks & Patios": px(4348404, "paver-install"),
  "Snow Removal": px(1939485, "snow-blower"),
  "Concrete & Masonry": px(1216584, "concrete-pour"),

  // === Construction & Remodeling ===
  "General Contractors": px(834892, "contractor"),
  "Kitchen Remodel": px(2724749, "kitchen"),
  "Bathroom Remodel": px(342800, "bath"),
  "Additions": px(534174, "addition"),
  "Basement Finishing": px(1571470, "basement"),
  "Tiling": px(2724748, "tile"),
  "Cabinetry": px(279648, "cabinet"),
  "Architects": px(323780, "architect"),

  // === Moving & Storage ===
  "Local Movers": px(7464018, "movers"),
  "Long-distance Movers": px(7464030, "long-move"),
  "Packing Services": px(4498136, "packing"),
  "Storage Units": px(4483608, "storage"),

  // === Auto Services ===
  "Auto Repair": px(279949, "auto-rep"),
  "Body Shops": px(5835359, "dented-car"),
  "Tires": px(244553, "tires-closeup"),
  "Oil Change Stations": px(4489702, "oil"),
  "Car Wash": px(6873082, "car-wash"),
  "Car Detailing": px(244206, "detail"),
  "Towing": px(2356045, "tow-truck"),
  "Auto Glass Services": px(3786091, "glass"),
  "Auto Parts": px(248528, "car-engine"),
  "Motorcycle Repair": px(2393821, "moto"),
  "RV Repair": px(2014775, "rv-motorhome"),

  // === Food & Drink ===
  "Restaurants": px(67468, "restaurant"),
  "Cafés & Coffee": px(312418, "cafe"),
  "Bakeries": px(1070946, "bakery"),
  "Bars": px(1267308, "bar"),
  "Breweries": px(1267700, "brewery"),
  "Caterers": px(587741, "cater"),
  "Food Trucks": px(2664216, "food-truck"),
  "Ice Cream & Frozen Yogurt": px(1132047, "ice-cream-cone"),
  "Juice Bars": px(96974, "juice"),
  "Specialty Food": px(372851, "specialty"),

  // === Beauty & Spas ===
  "Hair Salons": px(3992862, "woman-haircut"),
  "Barbers": px(1813346, "barber"),
  "Nail Salons": px(3997379, "nail"),
  "Skin Care": px(3997991, "woman-spa-face"),
  "Massage": px(3865711, "massage"),
  "Day Spas": px(8957104, "sauna"),
  "Tattoo & Piercing": px(1576939, "getting-tattoo"),
  "Makeup Artists": px(2533266, "makeup"),
  "Eyelash Service": px(2294342, "lash"),

  // === Health & Medical ===
  "Doctors": px(4173251, "doctor"),
  "Dentists": px(287237, "dentist"),
  "Chiropractors": px(7176026, "chiro"),
  "Physical Therapy": px(7659564, "pt"),
  "Optometrists": px(5752296, "optom"),
  "Mental Health": px(4101143, "mental"),
  "Pharmacy": px(208512, "pharma"),
  "Urgent Care": px(263402, "urgent"),
  "Acupuncture": px(6207364, "acupuncture"),
  "Dermatology": px(3997989, "derm"),

  // === Fitness ===
  "Gyms": px(1954524, "gym"),
  "Yoga Studios": px(3822622, "yoga"),
  "Pilates": px(917732, "pilates"),
  "Martial Arts": px(2294361, "martial"),
  "Personal Trainers": px(7991620, "trainer"),
  "Crossfit": px(917654, "crossfit"),
  "Dance Studios": px(1701202, "dance"),
  "Climbing": px(2647973, "climb"),

  // === Pets ===
  "Veterinarians": px(6816857, "vet"),
  "Pet Grooming": px(6816861, "groom"),
  "Pet Boarding": px(1390784, "board"),
  "Dog Walkers": px(1851164, "walk"),
  "Pet Training": px(1490908, "train"),
  "Pet Stores": px(4148015, "petstore"),

  // === Professional Services ===
  "Accountants": px(210990, "acct"),
  "Tax Services": px(6863183, "tax"),
  "Lawyers": px(5668858, "law"),
  "Insurance": px(7821485, "insurance"),
  "Notaries": px(4427814, "person-signing-paperwork"),
  "Marketing": px(265087, "marketing"),
  "Web Designers": px(326503, "webdes"),
  "IT Services": px(1181244, "it"),
  "Bookkeeping": px(6863176, "bookk"),
  "Translation Services": px(289738, "trans"),

  // === Real Estate ===
  "Real Estate Agents": px(8293700, "agent"),
  "Property Management": px(106399, "propmgmt"),
  "Mortgage Brokers": px(7821573, "mortgage"),
  "Home Inspectors": px(7641911, "inspect"),
  "Apartments": px(1571453, "apt"),

  // === Financial Services ===
  "Banks & Credit Unions": px(259200, "bank"),
  "Financial Advising": px(7821741, "advise"),
  "Investing": px(534216, "invest"),
  "Check Cashing": px(6694496, "check"),
  "ATMs": px(259027, "atm"),

  // === Education & Tutoring ===
  "Tutors": px(4145355, "tutor"),
  "Test Prep": px(265076, "testprep"),
  "Music Lessons": px(1751731, "music"),
  "Language Schools": px(256417, "lang"),
  "Driving Schools": px(116675, "driving"),
  "Childcare": px(8422165, "child"),
  "Preschools": px(8613067, "presch"),

  // === Events & Weddings ===
  "Wedding Planning": px(265908, "wedplan"),
  "Venues": px(3171837, "venue"),
  "Photographers": px(1854235, "photog"),
  "Videographers": px(2873486, "video"),
  "DJs": px(3784221, "dj"),
  "Florists": px(931177, "florist"),
  "Party Rentals": px(1359409, "party"),
  "Catering": px(541216, "catering"),

  // === Shopping ===
  "Grocery": px(264636, "grocery"),
  "Clothing": px(996329, "clothes"),
  "Bookstores": px(264635, "book"),
  "Electronics": px(2148216, "elec"),
  "Furniture": px(276528, "furn"),
  "Home Decor": px(1571463, "decor"),
  "Toys": px(459728, "toys"),
  "Jewelry": px(965982, "jewel"),
  "Sporting Goods": px(248547, "sport"),
  "Thrift Stores": px(1488463, "thrift"),
  "Dispensaries": px(7667731, "dispensary"),
  "Auctions": px(7621383, "auction-gavel"),
  "Liquidators": px(6347545, "warehouse-pallets"),
  "Pop-Up Shops": px(1884581, "pop-up-market"),
  "Antiques": px(207142, "antique"),
  "Eyewear": px(343720, "eyewear"),

  // === Arts & Entertainment ===
  "Movie Theaters": px(7991158, "movie"),
  "Museums": px(2519376, "museum"),
  "Music Venues": px(167636, "musicv"),
  "Art Galleries": px(196652, "gallery"),
  "Bowling": px(344029, "bowl"),
  "Arcades": px(371924, "arcade"),
  "Escape Rooms": px(7180810, "escape"),

  // === Nightlife ===
  "Lounges": px(338713, "lounge"),
  "Cocktail Bars": px(1283219, "cocktail"),
  "Sports Bars": px(2122294, "sportsbar"),
  "Dance Clubs": px(1540406, "dancec"),
  "Karaoke": px(1916818, "karaoke"),
  "Pubs": px(605408, "pub"),

  // === Hotels & Travel ===
  "Hotels": px(261395, "hotel-room"),
  "Bed & Breakfast": px(271619, "bb"),
  "Vacation Rentals": px(261101, "rental"),
  "Travel Agents": px(346885, "travel"),
  "Car Rental": px(170811, "carrent"),
  "Airport Shuttles": px(2026324, "shuttle"),

  // === Local Services ===
  "Dry Cleaning": px(5816300, "dry"),
  "Tailors": px(4622972, "tailor"),
  "Shoe Repair": px(267301, "shoe"),
  "Watch Repair": px(280250, "watch"),
  "Couriers": px(4391470, "courier"),
  "Printing Services": px(1029757, "print"),
  "Recycling Center": px(802222, "recycle"),

  // === Childcare & Family ===
  "Daycare": px(8612918, "daycare"),
  "Nannies": px(1471843, "nanny"),
  "Babysitters": px(3661243, "sitter"),
  "After-school Programs": px(8612967, "afterschool"),
  "Summer Camps": px(6209552, "camp"),

  // === Religious & Community ===
  "Churches": px(208369, "church"),
  "Mosques": px(2087390, "mosque"),
  "Synagogues": px(1486577, "synagogue"),
  "Community Centers": px(2422278, "communityctr"),
  "Non-profits": px(6646918, "nonprofit"),

  // === Technology ===
  "Computer Repair": px(442150, "computerrep"),
  "Phone Repair": px(4040527, "phonerep"),
  "Software Development": px(546819, "swdev"),
  "Networking": px(1148820, "network"),
  "Smart Home Installation": px(5876512, "smarthome"),

  // === Senior & Disability ===
  "Senior Care": px(7551611, "seniorcare"),
  "Home Health Aides": px(7551634, "aide"),
  "Hospice": px(7551610, "hospice"),
  "Assisted Living": px(7551614, "assisted"),
  "Accessibility Modifications": px(7551613, "access"),
};

export const FALLBACK_CATEGORY_IMAGE = px(1170412, "fallback");
